/* globals mozRTCSessionDescription, RTCSessionDescription */
'use strict';

module.exports = typeof RTCSessionDescription !== 'undefined'
  ? RTCSessionDescription
  : mozRTCSessionDescription;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/webrtc/lib/rtcsessiondescription/firefox.js
// module id = lpxd
// module chunks = 0